import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'paBookAppointmentDoctorPipe'
})
export class PaBookAppointmentDoctorPipePipe implements PipeTransform {

 
  transform(doctorData: any[], searchTermDocList: string): any[]{
    if (!doctorData || !searchTermDocList) { return doctorData; }
    return doctorData.filter(ad =>
     
    
      ad.name.toLowerCase().indexOf(searchTermDocList.toLowerCase().trim()) !== -1 ||
      ad.emailId.toLowerCase().indexOf(searchTermDocList.toLowerCase().trim()) !== -1
  
  
  
  
    );
  }

}
